import { useFormContext } from 'react-hook-form'
import Button from '../../../Button'
import React from 'react'

export type TimeOptions = 'now' | '10s' | '30m' | '8h'

export const convertTimeString = (date: Date) => {
  return date.toISOString().replace('T', ' ').split('.')[0]
}

export const setTime = <T,>(
  option: TimeOptions,
  input: keyof T,
  setValue: (input: string, value: string) => void
) => {
  if (option === 'now') {
    setValue(input.toString(), convertTimeString(new Date()))
  }
  if (option === '10s') {
    setValue(input.toString(), convertTimeString(new Date(Date.now() + 10000)))
  }
  if (option === '30m') {
    setValue(input.toString(), convertTimeString(new Date(Date.now() + 1.8e6)))
  }
  if (option === '8h') {
    setValue(input.toString(), convertTimeString(new Date(Date.now() + 2.88e7)))
  }
}

export const SetTimeButton = <T,>({
  time,
  inputId
}: {
  time: TimeOptions
  inputId: keyof T
}) => {
  const { setValue } = useFormContext()
  return (
    <Button
      theme="clean-blue"
      size="sm"
      onClick={() => setTime(time, inputId, setValue)}
    >
      {time}
    </Button>
  )
}

export const SetNowButton = <T,>({ inputId }) => (
  <SetTimeButton time="now" inputId={inputId as keyof T} />
)
